import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import {
    Button, Card, CardContent, CardActions, Container, Typography, 
} from '@material-ui/core';
import { LockOutline } from "mdi-material-ui";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignContent: 'center',
        height: '90vh',
        width: '100%'
    },
    pageTitleDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        textAlign: 'center',
        padding: 30
    },
}));
export default function AccessDenied() {
    const classes = useStyles();
    const history = useHistory();
    const authStore = useSelector((state) => state.authentification)
    const defaultPage = authStore?.user.defaultPage

    return (
        <Container className={classes.container}>
            <Card className={classes.pageTitleDiv}>
                <CardContent>
                <Typography variant='h4' gutterBottom>
                    Access Denied
                </Typography>
                <LockOutline style={{fontSize: '200px'}}/>
                <Typography variant='body1'>
                        If this is a mistake, please contact your administrator.
                </Typography>
                </CardContent>
                <CardActions style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                    <Button variant='contained' fullWidth color='default' onClick={() => defaultPage ? history.push(defaultPage) : history.push('/')}>
                        Home
                        </Button>
                    </CardActions>
            </Card>
        </Container>
    )
}